const ContactLinks = () => {

    const handleNo = (txt, target) => {
        console.log(target, "target");
        if (target) {
            window.open(txt, '_blank');
        } else {
            window.location.href = txt; // ✅ correct way for mailto
        }
    }

    return (
        <>
            <div className='row  info-part'>
                <div className="col-md-4">
                    <div className='info-btn'>
                        <a href="mailto:support@kittrowcapital.com">
                            <img src="assets/images/email1.png" /><br />
                            <span>Email</span>
                        </a>
                        <div onClick={() => handleNo('mailto:support@kittrowcapital.com', false)} style={{ "cursor": "pointer" }}>
                            <h3>support@kittrowcapital.com</h3>
                        </div>
                    </div>


                </div>

                <div className="col-md-4">
                    <div className='info-btn'>
                        <a href='tel:+42-0296249177'>
                            <img src="assets/images/phone.png" /><br />
                            <span>Phone</span>
                        </a>
                        <div onClick={() => handleNo('tel:+42-0296249177', false)} style={{ "cursor": "pointer" }}>
                            <h3>+42-0296249177</h3>
                        </div>
                    </div>


                </div>

                <div className="col-md-4">
                    <div className='info-btn'>
                        <a target="_blank" href="https://t.me/kittrow">
                            <img src="assets/images/teegram.png" /><br />
                            <span></span>
                        </a>
                        <div onClick={() => handleNo('https://t.me/kittrow', true)} style={{ "cursor": "pointer" }}>
                            <h3>Telegram</h3>
                        </div>
                    </div>


                </div>

                <div className="col-md-8">
                    <div className='info-btn'>
                        <a target="_blank" href="https://maps.app.goo.gl/avptja3zJMY9uqUp6">
                            <img src="assets/images/office.png" /><br />
                            <span>Office Address</span>
                        </a>
                        <div onClick={() => handleNo('https://maps.app.goo.gl/avptja3zJMY9uqUp6', true)} style={{ "cursor": "pointer" }}>
                            <h3>Cimburkova 916/8, Prague, 130 00</h3>
                        </div>
                    </div>


                </div>

                <div className="col-md-4">
                    <div className='info-btn'>
                        <a target="_blank" href='https://wa.me/+420296249177'>
                            <img src="assets/images/WhatsApp.png" /><br />
                            <span></span>
                        </a>
                        <div onClick={() => handleNo('https://wa.me/+420296249177', true)} style={{ "cursor": "pointer" }}>
                            <h3>WhatsApp</h3>
                        </div>
                    </div>


                </div>



            </div>
        </>
    );
}

export default ContactLinks;